// Configuration for different campaigns based on 's' query parameter
const CAMPAIGN_CONFIG = {
    80: {
        AW_ID: 'AW-10917410025',
        LABELS: {
            LEAD_SUBMIT: 'HKZDCIiOja8YEOnp6dUo',
            HOTLINE: 'C_RpCO2ZjK4YEOnp6dUo',
            WHATSAPP: 'Uv8UCIeolK8YEOnp6dUo',
        },
    },
    166: {
        AW_ID: 'AW-11282673507',
        LABELS: {
            LEAD_SUBMIT: '_GpxCOGWrYEZEOPe_4Mq',
            HOTLINE: '72LeCMqdrYEZEOPe_4Mq',
            WHATSAPP: 'LNjGCL-hrYEZEOPe_4Mq',
        },
    },
    179: {
        AW_ID: 'AW-10917410025',
        LABELS: {
            LEAD_SUBMIT: 'kyiPCLqe_J0ZEOnp6dUo',
            HOTLINE: 'tkocCKrmip4ZEOnp6dUo',
            WHATSAPP: 'aQzSCN3BhJ4ZEOnp6dUo',
        },
    },
    238: {
        AW_ID: 'AW-11282673507',
        LABELS: {
            LEAD_SUBMIT: 'cwkTCL-n3qUaEOPe_4Mq',
            HOTLINE: 'W3mSCPTK0agaEOPe_4Mq',
            WHATSAPP: 'BU6ZCJ_7-5waEOPe_4Mq',
        },
    },
};

const FB_PIXEL_IDS = ['6455600277835012', '213497411659650', '570984462465785'];

let currentConfig = null;

export const initTracking = () => {
    // 1. Get query parameter 's'
    const searchParams = new URLSearchParams(window.location.search);
    const sParam = searchParams.get('s');
    // Default to 80 if s is not present, similar to the PHP logic: $s = $_GET['s'] ?? 80;
    const s = sParam ? parseInt(sParam) : 80;

    if (!CAMPAIGN_CONFIG[s]) {
        console.warn(`Tracking: Unknown campaign ID s=${s}. Defaulting to s=80.`);
        currentConfig = CAMPAIGN_CONFIG[80];
    } else {
        currentConfig = CAMPAIGN_CONFIG[s];
    }

    const { AW_ID } = currentConfig;

    // 2. Initialize Google Tag Manager (GTag)
    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${AW_ID}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];
    function gtag() { window.dataLayer.push(arguments); }
    window.gtag = gtag; // Make globally available
    gtag('js', new Date());
    gtag('config', AW_ID);

    // 3. Initialize Meta Pixel (Multiple IDs)
    (function (f, b, e, v, n, t, s) {
        if (f.fbq) return; n = f.fbq = function () {
            n.callMethod ?
            n.callMethod.apply(n, arguments) : n.queue.push(arguments)
        };
        if (!f._fbq) f._fbq = n; n.push = n; n.loaded = !0; n.version = '2.0';
        n.queue = []; t = b.createElement(e); t.async = !0;
        t.src = v; s = b.getElementsByTagName(e)[0];
        s.parentNode.insertBefore(t, s)
    }(window, document, 'script',
        'https://connect.facebook.net/en_US/fbevents.js'));

    if (window.fbq) {
        FB_PIXEL_IDS.forEach(id => {
            window.fbq('init', id);
        });
        window.fbq('track', 'PageView');
    }

    console.log(`Tracking: Initialized for campaign s=${s} (${AW_ID})`);
};

// Helper for GTag Conversion
const fireGTagConversion = (labelKey) => {
    if (!currentConfig || !currentConfig.LABELS[labelKey]) return;
    const { AW_ID, LABELS } = currentConfig;
    const sendTo = `${AW_ID}/${LABELS[labelKey]}`;

    if (window.gtag) {
        window.gtag('event', 'conversion', { 'send_to': sendTo });
        console.log(`Tracking: Fired GTag ${labelKey} conversion to ${sendTo}`);
    }
};

// Helper for Clarity Event
const fireClarityEvent = (eventName) => {
    if (window.clarity) {
        window.clarity('event', eventName);
        console.log(`Tracking: Fired Clarity event '${eventName}'`);
    }
};

// Helper for FB Custom Event
const fireFBEvent = (eventName) => {
    if (window.fbq) {
        window.fbq('trackCustom', eventName);
        console.log(`Tracking: Fired FBQ custom event '${eventName}'`);
    }
};

export const trackLeadSubmit = () => {
    fireGTagConversion('LEAD_SUBMIT');
    fireClarityEvent('formSubmit');
    // PHP didn't explicitly show fbq('trackCustom', 'formSubmit'), but user request implies adding these conventions now.
    // However, looking closely at the PHP for leadSubmit function, it does: window.clarity('event', 'formSubmit');
    // but verifies only logic for WA and PDF for FBQ custom.
    // The prompt says "add these convertio now", looking at the PHP for `leadSubmit`: 
    // it has `window.clarity('event', 'formSubmit');`. It does NOT have FBQ.
    // BUT the prompt request "add these convetions now" might imply full coverage.
    // I will stick strictly to the PHP logic provided for Lead Submit: Only GTag + Clarity.
};

export const trackHotline = () => {
    fireGTagConversion('HOTLINE');
    // PHP `hotlineConv` only does GTag. No Clarity or FBQ.
};

export const trackWhatsApp = () => {
    fireGTagConversion('WHATSAPP');
    fireClarityEvent('Wa-Conversion');
    fireFBEvent('Wa-Conversion');
};

export const trackPDFDownload = () => {
    // PHP `pdfDownload`: window.clarity('event', 'salaPDFDownload'); fbq('trackCustom', 'salaPDFDownload');
    // No GTag conversion for PDF in the PHP snippets provided (function is defined but not called in the switch).
    // I will implement the event firing as requested.
    fireClarityEvent('salaPDFDownload');
    fireFBEvent('salaPDFDownload');
};
